import { Box } from "@mui/system";
import React, { useCallback, useState, useEffect, Fragment } from "react";
import MuiTab from "../../CommonComponents/Tab/MuiTab";
import FilterPopOver from "../CaseManagement/CaseManagementFilter/FilterPopOver";
import CommonButton from "../../CommonComponents/CommonButton";
import useToaster from "../../customHook/useToaster";
import DownloadIcon from "../../Images/Svg/DownloadIcon.svg";
import style from "./VendorManagement.module.css";
import { images } from "../../Images/Svg/index";
import TableComponent from "../../CommonComponents/Table";
import {
  gridContent,
  standardTabelData,
  vendorTabLabel,
  vendorTabelData,
  VendorMasterActionList,
} from "../../constants/VendorManagementTableData";
import TableGrid from "../../CommonComponents/TableGridView/TableGrid";
import { useDispatch } from "react-redux";
import { pageLimit } from "../../Utils/helper";
import CommonModal from "../../CommonComponents/Modal/CommonModal";
import AuditReport from "./AuditReport";
import { defaultCaseActionList } from "../../constants/utils";
import {
  getAllCasesListVendor,
  getAllCasesSegmentInfoVendor,
} from "../../Services/VendorManagement";
import { useNavigate } from "react-router";
import { Skeleton } from "@mui/material";
import TableSkeleton from "../../CommonComponents/TableSkeleton";

const { addIcon } = images;

let buttonStyle = {
  fontSize: "2.8rem",
  paddingTop: "0.4rem",
  paddingBottom: "0.4rem",
};

const VendorManagement = () => {
  const { showToast } = useToaster();
  const [tabIndexValue, setTabIndexValue] = useState(0);
  const [firstTabIndexValue, setFirstTabIndexValue] = useState(0);
  const [page, setPage] = useState(1);
  const [displaySecondTab, setDisplaySecondTab] = useState(false);
  const [secondTabIndex, setSecondTabIndex] = useState(0);
  const [secondTabVal, setSecondTabVal] = useState("Vendor Details");
  const [openActionModal, setOpenActionModal] = useState(false);
  const [actionModalType, setActionModalType] = useState("");
  const [selectedCollapseId, setSelectedCollapseId] = useState(0);
  const [firstTabVal, setFirstTabVal] = useState("Vendor");
  const [actionTabState, setActionTabState] = useState([]);
  const [vendorManagementDataState, setVendorManagementDataState] = useState(
    []
  );
  const [
    vendorManagementSegmentInfoState,
    setVendorManagementSegmentInfoState,
  ] = useState([]);
  const [count, setCount] = useState(0);
  const [vendorCompanyId, setVendorCompanyId] = useState();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const rowsPerPage = pageLimit;

  const onCellClicked = useCallback(
    (e, colid, colValue, lobName, index) => {
      let getVendorCompanyId = vendorManagementDataState?.find(
        (obj) => obj?.vendor_employees?.employee_name === colValue
      )?.vendor_company_id;
      setVendorCompanyId(getVendorCompanyId);
    },
    [secondTabVal, vendorManagementDataState]
  );

  const firstTabChangeClickHandler = useCallback(
    (event, newValue) => {
      setVendorManagementDataState([]);
      setFirstTabVal(event.target.innerText.split(" ")[0]);
      setFirstTabIndexValue(newValue);
      setDisplaySecondTab(false);
      setSecondTabIndex(0);
      setSelectedCollapseId(null);
      setPage(1);
    },
    [firstTabVal]
  );

  useEffect(() => {
    ActionTabContent(firstTabVal);
  }, [firstTabVal]);

  const ActionTabContent = useCallback((firstTabVal) => {
    switch (firstTabVal) {
      case "Vendor":
        setActionTabState(VendorMasterActionList);
        break;
      default:
        setActionTabState(defaultCaseActionList);
    }
  }, []);

  const actionFactory = useCallback((x) => {
    let component = null;
    switch (x) {
      case "Audit":
        component = <AuditReport />;
        break;
      default:
        return "Coming Soon...";
    }
    return component;
  }, []);

  const renderActionComponent = useCallback(() => {
    return actionFactory(actionModalType);
  }, [actionFactory, actionModalType]);

  const onClickFirstPopper = useCallback(
    async (e, type) => {
      if (type === "view") {
        if (displaySecondTab) {
          setDisplaySecondTab(false);
          setTimeout(() => {
            setDisplaySecondTab(true);
          }, 50);
        } else {
          setDisplaySecondTab(true);
        }
        setDisplaySecondTab(true);
        setSecondTabVal("Vendor Details");
        setSecondTabIndex(0);
        setSelectedCollapseId(null);
      } else {
        setOpenActionModal(true);
        setActionModalType(type);
      }
    },
    [displaySecondTab, firstTabVal]
  );

  const secondTabChangeClickHandler = useCallback((event, newValue) => {
    setSecondTabVal(event.target.innerText);
    setTabIndexValue(newValue);
  }, []);

  const firstButtonClicked = useCallback(() => {
    setPage(1);
  }, []);
  const lastButtonClicked = useCallback(() => {
    setPage(Math.ceil(count / rowsPerPage));
  }, [rowsPerPage, count]);
  const handleNextButtonClick = useCallback(() => {
    setPage((page) => page + 1);
  }, []);
  const handleBackButtonClick = useCallback(() => {
    setPage((page) => page - 1);
  }, []);
  const onPageDropdownChange = useCallback((e) => {
    setPage(Number(e.target.value));
  }, []);

  useEffect(() => {
    if (firstTabIndexValue === 0) {
      const offset = (page - 1) * pageLimit;
      getAllCasesListVendor(firstTabVal, offset)
        .then((data) => {
          if (data?.success) {
            showToast("List Fetched", "success", true);
            let vendorManagementData = data?.data?.result?.map(
              (item, i, arr) => {
                arr[i] = {
                  ...arr[i],
                  srNo: offset + i + 1,
                  mobile_number: item?.vendor_employees?.mobile_number,
                  createdAt: new Date(item?.createdAt).toLocaleDateString(),
                  company_name: item?.vendor_employees?.employee_name,
                };
                return arr[i];
              }
            );
            setVendorManagementDataState(vendorManagementData);
            setCount(data?.data?.count);
          } else {
            setVendorManagementDataState([]);
            showToast(data?.message || "Error in fetching list", "error", true);
          }
        })
        .catch((err) => {
          setVendorManagementDataState([]);
          if (err?.response?.data?.message === "No such status exist.") {
            return showToast("Coming soon", "success", true);
          }
          showToast(
            err?.response?.data?.message || "Error in fetching list",
            "error",
            true
          );
        });
    } else {
      showToast("Coming Soon", "success", true);
    }
  }, [firstTabVal, page]);

  const getAllCasesSegmentInfoFun = useCallback(() => {
    let dataApi = {
      company_vendor_id: vendorCompanyId,
    };
    let secondTabValLower =
      secondTabVal.charAt(0).toLowerCase() + secondTabVal.slice(1);
    if (secondTabVal === "Vendor Details") {
      setSecondTabVal("basic Details");
    }
    getAllCasesSegmentInfoVendor(
      secondTabValLower.split(" ")[0],
      vendorCompanyId,
      dataApi
    )
      .then((data) => {
        if (data?.success) {
          let vendorManagementSegmentInfoData = data.data;
          setVendorManagementSegmentInfoState(vendorManagementSegmentInfoData);
        }
      })
      .catch((error) => {
        setVendorManagementSegmentInfoState({});

        showToast("Error In Fetching Segment Info", "error", true);
      });
  }, [secondTabVal]);
  useEffect(() => {
    if (displaySecondTab) getAllCasesSegmentInfoFun();
  }, [secondTabIndex, displaySecondTab, getAllCasesSegmentInfoFun]);
  return (
    <Box sx={{ marginTop: "2.5rem" }}>
      <h1 className={style["header"]}>Vendor Management</h1>
      <Box sx={{ display: "flex", marginLeft: "1rem" }}>
        <MuiTab tabs={vendorTabLabel} onClick={firstTabChangeClickHandler} />
        <div className={style["rightSide_Icon_btn"]}>
          <CommonButton
            label="Add Vendor"
            isIcon={true}
            iconName={
              <img src={addIcon} alt="Download Icon" style={buttonStyle} />
            }
            backgroundColor={"#ffffff"}
            textColor={"#E42125"}
            removeBorder={true}
            smallButton={true}
            filledButton={false}
            removeBackGround={true}
            sx={{ width: "15rem", height: "4rem" }}
            onClick={() => navigate("/vendorOnboarding")}
          />
          <div style={{ width: "max-content" }}>
            <FilterPopOver
            //   isDateFilterClicked={isDateFilterClicked}
            //   isStatusFilterClicked={isStatusFilterClicked}
            //   isDateIconClicked={isDateIconClicked}
            //   isStatusIconClicked={isStatusIconClicked}
            //   isStatusItemClicked={isStatusItemClicked}
            //   anchorEl={anchorEl}
            //   dateFilterHandler={dateFilterHandler}
            //   statusFilterHandler={statusFilterHandler}
            //   statusItemHandler={statusItemHandler}
            //   startDateHandler={startDateHandler}
            //   endDateHandler={endDateHandler}
            //   handleFilterByTag={handleFilterByTag}
            //   handleClick={handleClick}
            //   handleClose={handleClose}
            //   handleFilterApply={handleFilterApply}
            //   handleFilterReset={handleFilterReset}
            />
          </div>
          <div style={{ width: "max-content" }}>
            <CommonButton
              label=""
              isIcon={true}
              iconName={
                <img
                  src={DownloadIcon}
                  alt="Download Icon"
                  style={buttonStyle}
                />
              }
              backgroundColor={"#ffffff"}
              textColor={"#E42125"}
              removeBorder={true}
              smallButton={true}
              filledButton={false}
              removeBackGround={true}
              onClick={() => showToast("Coming soon", "info", true)}
            />
          </div>
        </div>
      </Box>
      <CommonModal
        // showCrossIcon={actionModalType === "Vendor Assessment" ? true : false}
        showCrossIcon={true}
        width={actionModalType === "Vendor Assessment" ? "45%" : "30%"}
        open={openActionModal}
        onClose={() => setOpenActionModal(false)}
      >
        {renderActionComponent()}
      </CommonModal>
      <Box sx={{ marginLeft: "2.5rem" }}>
        <div style={{ marginTop: "0.9rem" }}>
          {vendorManagementDataState?.length ? (
            <TableComponent
              stickyHeader={false}
              columnHeaderBackgroundColor={"#FCF7FF"}
              columnHeaderColor={"#242424"}
              columnHeaderFontWeight={600}
              columnBodyFontWeight={400}
              page={page}
              rowsPerPage={rowsPerPage}
              count={count}
              firstButtonClicked={firstButtonClicked}
              lastButtonClicked={lastButtonClicked}
              handleNextButtonClick={handleNextButtonClick}
              handleBackButtonClick={handleBackButtonClick}
              onPageDropdownChange={onPageDropdownChange}
              setPage={setPage}
              rowsData={vendorManagementDataState}
              columnsData={vendorTabelData[firstTabIndexValue].column}
              hideBorders={true}
              secondPopperListItem={actionTabState}
              alternnateStyledRow={true}
              alternnateStyledRowColor={"#FBF5FF"}
              onClickFirstPopper={onClickFirstPopper}
              onCellClicked={onCellClicked}
              popperContentMatch={"company_name"}
            />
          ) : (
            <TableSkeleton />
          )}
        </div>
        {displaySecondTab && (
          <>
            <MuiTab
              tabs={standardTabelData}
              variant="standard"
              onClick={secondTabChangeClickHandler}
            />
            <TableGrid
              backgroundColor="#FFFFFF"
              boxShadow="0px 5px 25px rgba(0, 0, 0, 0.06)"
              gridContent={vendorManagementSegmentInfoState}
            />
          </>
        )}
      </Box>
    </Box>
  );
};

export default VendorManagement;
